{
    "login": false,
    "userSchool": false,
    "userSchoolActive":false,
    "changePassword": false,
    "gallery": false,
    "galleryActive": false,
    "testimonial": false,
    "testimonialActive": false,
    "facility": false,
    "facilityActive": false,
    "career": false,
    "application": false,
    "state": false,
    "city": false,
    "contactus": false,
    "getBanners": false,
    "bannerStatus":false
}